export default __webpack_public_path__ + "static/media/clientCase3.6a3710be.png";